import { Content } from "./profileElements";
import React from "react";

const Profile = () => {
  return <Content />;
};
export default Profile;
